/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-var: 0 */
/* globals _, hex_md5, mp */

/*
 * Provides:
 *  mp.api.middleware.Cache
 *  mp.api.middleware.TimedCache
 *
 * Requires:
 *  mp.api.Middleware
 *  md5.js
 */



_.namespace(`mp.api.middleware`, function() {
  "use strict";
  function Cache() {}
  _.inherit(Cache, mp.api.Middleware);

  Cache.prototype.init = function() {
    this._cache = {};
    return Cache.superclass.init.apply(this, arguments);
  };

  Cache.prototype.default_config = function() {
    return _.extend(Cache.superclass.default_config.call(this), {
      read_through: false,
    });
  };

  Cache.prototype._generate_cache_key = function(request) {
    var data = request.endpoint + JSON.stringify(request.params);
    return hex_md5(data);
  };

  Cache.prototype.on_request = function(request, next) {
    if (request.params.nocache) {
      request.nocache = true;
      delete request.params.nocache;
      return next(request);
    } else {
      request.cache_key = this._generate_cache_key(request);
      if (_.has(this._cache, request.cache_key)) {
        var response = this._cache[request.cache_key];
        request.cache_hit = true;
        if (this.config.read_through) {
          if (_.isFunction(request.callback)) {
            request.callback(response, request);
          }
          request.callback = function() {};
          return next(request);
        } else {
          return next(request, response);
        }
      } else {
        request.cache_hit = false;
        return next(request);
      }
    }
  };

  Cache.prototype.on_response = function(request, response, next) {
    if (request.nocache || (_.isString(request.method) && request.method.toUpperCase() !== `GET`)) {
      next(request, response);
    } else {
      if (!request.cache_key) {
        request.cache_key = this._generate_cache_key(request);
      }
      this._cache[request.cache_key] = response;
      next(request, response);
    }
  };

  function TimedCache() {}
  _.inherit(TimedCache, Cache);

  TimedCache.prototype.default_config = function() {
    return _.extend(TimedCache.superclass.default_config.call(this), {
      cache_timeout: 30000, // 30 second cache
      refresh_cache: false,
    });
  };
  TimedCache.prototype.reset = function() {
    TimedCache.superclass.reset.apply(this, arguments);
    this._cache_timeouts = {};
    this._reaper();
  };

  TimedCache.prototype._reaper = function() {
    var reaper_timeout = 1000;
    if (this.config.cache_timeout < reaper_timeout) {
      reaper_timeout = this.config.cache_timeout;
    }

    if (typeof(this._reaper_id) !== `undefined`) {
      window.clearTimeout(this._reaper_id);
    }

    var reaper = _.bind(function() {
      var tse = new Date().getTime();

      _.each(this._cache_timeouts, function(value, key) {
        if (tse - value > this.config.cache_timeout) {
          delete this._cache[key];
          delete this._cache_timeouts[key];
          //mp.utility.log('CACHE: Reaped ' + key);
        }
      }, this);

      this._reaper_id = window.setTimeout(reaper, reaper_timeout);
    }, this);

    reaper();
  };

  TimedCache.prototype.on_response = function(request, response, next) {
    if (!request.cache_key) { request.cache_key = this._generate_cache_key(request); }

    if (this.config.refresh_cache || !Object.prototype.hasOwnProperty.call(this._cache_timeouts, request.cache_key)) {
      this._cache_timeouts[request.cache_key] = new Date().getTime();
    }

    TimedCache.superclass.on_response.apply(this, arguments);
  };

  return {
    Cache,
    TimedCache,
  };
});

}.call(window));